import { filterAssignments } from '../actions/filter';

function getUnfilteredAssignmentsFromState(state) {
  if (state.unfilteredAssignments && state.unfilteredAssignments.length) {
    return state.unfilteredAssignments;
  }

  return state.assignments || [];
}

function filterStudentsByAssignmentIds(students, filteredAssignmentIds) {
  return (students || []).map((student) => ({
    ...student,
    assignments: (
      student.unfilteredAssignments ||
      student.assignments ||
      []
    ).filter((assignment) => filteredAssignmentIds.has(assignment.id)),
  }));
}

function applyResourceTypeFiltersToGradebookState(state) {
  const unfilteredAssignments = getUnfilteredAssignmentsFromState(state);
  const filteredAssignments = filterAssignments(unfilteredAssignments, {
    filterTypes: state.filterTypes,
    search: state.searchPhrase,
    searchType: state.searchType,
    searchDateFrom: state.searchDateFrom,
    searchDateTo: state.searchDateTo,
  });
  const filteredAssignmentIds = new Set(
    filteredAssignments.map((assignment) => assignment.id),
  );

  return {
    ...state,
    unfilteredAssignments,
    assignments: filteredAssignments,
    students: filterStudentsByAssignmentIds(
      state.students,
      filteredAssignmentIds,
    ),
  };
}

export {
  getUnfilteredAssignmentsFromState,
  filterStudentsByAssignmentIds,
  applyResourceTypeFiltersToGradebookState,
};
